export default {

	init() {
		console.log('init nav...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
        const header = document.querySelector('.site-header');
        const toggle = document.querySelector('.menu-toggle');
        const menu = document.querySelector('.header-menu');

        Nav.header = header;
        Nav.navToggle = toggle;
        Nav.navMenu = menu;

        // Mobile menu toggle
        toggle.addEventListener('click', Nav.toggleNav);

		// Scroll watcher
        Nav.navScrollWatcher();
    },

    toggleNav(e) {
        if (Nav.navMenu.classList.contains('is-open')) {
            Nav.closeNav();
        } else {
            Nav.openNav();
        }
    },

    openNav() {
        document.querySelector('html').classList.add('is-nav-open');
        Nav.navMenu.classList.add('is-open');
        Nav.navToggle.setAttribute('aria-expanded', 'true');

        // Listen for resize and close menus
        window.addEventListener('resize', Nav.navState, false);
    },

    closeNav() {
        document.querySelector('html').classList.remove('is-nav-open');
        Nav.navMenu.classList.remove('is-open');
        Nav.navToggle.setAttribute('aria-expanded', 'false');

        // Stop listening for resize
        window.removeEventListener('resize', Nav.navState, false);
    },

	navState() {
        Nav.closeNav();
    },

	navFixedState() {
        let threshold = Nav.header.offsetHeight * 0.33;

        if (window.scrollY > Nav.scrollPreviousY) {
            Nav.scrollDirection = 'down'
        } else {
            Nav.scrollDirection = 'up'
        }

        Nav.scrollPreviousY = window.scrollY;

        if (Nav.scrollPreviousY > threshold) {
			Nav.header.classList.add('is-header-fixed');
			document.querySelector('body').classList.add('has-fixed-header');
        } else {
            Nav.header.classList.remove('is-header-fixed');
			document.querySelector('body').classList.remove('has-fixed-header');
        }

		if (Nav.scrollDirection === 'down' && Nav.scrollPreviousY > threshold) {
			Nav.header.classList.add('is-header-fixed-hidden');
        } else {
			Nav.header.classList.remove('is-header-fixed-hidden');
		}
    },

    navScrollWatcher() {
        let prevY = 0;
        let direction = 'up';

        Nav.scrollDirection = direction;
        Nav.scrollPreviousY = prevY;

        Nav.navFixedState();
        window.addEventListener('scroll', Nav.navFixedState);
    },

};
